import { render, staticRenderFns } from "./firsttimedialog.vue?vue&type=template&id=4a5a81fe&scoped=true"
import script from "./firsttimedialog.vue?vue&type=script&lang=js"
export * from "./firsttimedialog.vue?vue&type=script&lang=js"
import style0 from "./firsttimedialog.vue?vue&type=style&index=0&id=4a5a81fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a81fe",
  null
  
)

export default component.exports